import React, {useState, useEffect} from 'react'
import { connect } from 'react-redux';
import styles from "./IndicatorsDashbordActivity.module.css";

import {getVka, getUniversity, trashVkaData} from '../../../../actions/report'

import BtnBack from '../../helper/btnBack/BtnBack';
import GetHeader from '../../helper/getHeader/GetHeader';
import back1 from '../../../../assets/dashboard/background_1.png'

const monthList = [
  {en: 'sep', ru: 'сен'},
  {en: 'oct', ru: 'окт'}, 
  {en: 'nov', ru: 'нов'}, 
  {en: 'dec', ru: 'дек'}, 
  {en: 'jan', ru: 'янв'}, 
  {en: 'feb', ru: 'фев'}, 
  {en: 'mar', ru: 'мар'}, 
  {en: 'apr', ru: 'апр'}, 
  {en: 'may', ru: 'май'}, 
  {en: 'jun', ru: 'июн'}, 
  {en: 'jul', ru: 'июл'}, 
  {en: 'aug', ru: 'авг'} 
]

const colors = ['red', 'blue', 'green', 'blueviolet', 'orange'];

const IndicatorsDashbordActivity = ({
  vka,
  getVka,
  university,
  getUniversity,
  match,
  trashVkaData
}) => {

const { id } = match.params

const [uni, setUni] = useState(null);

useEffect(() => {
  !university?.length && getUniversity();
}, [])

useEffect(() => {
  if (university && university.length > 0 && id != null) {
    const [one, two] = id.split('_');
    const univer = two ? university[one].branches[two] : university[one]
    const prefix = univer?.api_url
    prefix?.length > 1 ? getVka(prefix) : trashVkaData()
    setUni(univer)
  }
}, [university]);


const getRusMonth = ( month ) => {
  return monthList.find(el => el.en == month)
}

const getColor = ( perc ) => {
  let color = [];
  if (perc < 50) {
    color = ['#edb9b8', '#d45142']
  } else if (perc >= 50 && perc <= 80) {
    color = ['#d0dfb8', '#72ba35']
  } else if (perc > 80) {
    color = ['#a6e0c1', '#1cc47c']
  }
  return color;
}

const getSum = (data) => data?.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0); //Получаем сумму баллов
const getPers = (data, sum) => data?.map(el=> `${el.count / (sum / 100)}` ).sort( (a, b) => a - b); //Получаем отсортированный список баллов в процентах

  const getValues = (data) => {
    const sum = getSum(data)
    const toPersList = getPers(data, sum);

    let start = toPersList && [`${colors[0]} 0% ${toPersList[0]}%`]; //Стартовый массив
    let persSumm = toPersList && +toPersList[0]; //Сумма процентов
    const x = toPersList?.map((el, inx) => {
      if (inx > 0 && toPersList.length - 1 != inx) {
        persSumm = persSumm + +el;
        start.push(`${colors[inx]} ${toPersList[inx - 1]}% ${Number(persSumm).toFixed(2)}%`)
      }

      if (toPersList.length - 1 == inx) {
        if (toPersList.length == 2) {
        } 
        start.push(`${colors[inx]} ${Number(persSumm).toFixed(2)}%`)
      }
      
    })

    return start;
  }
  
  const getConicGradient = (data) => {
    const x = `conic-gradient(${getValues(data)?.map(el => `${el}`)})`; //Формируем сonic-пradient css-стиль 
    return x;
  }

  return (
    <div className={styles.wrapper}>
      <img src={back1} className={styles.bg}/>
      <GetHeader title={<>Показатели деятельности организации <br/> {uni?.name}</>}/>

      {vka &&
        <div className={styles.wrapperInner}>

        <div className={styles.leftBlock}>
          <div className={styles.title}>Профессорско-<br/>преподовательский<br/>состав</div>
          <span className={styles.info}>Военнослужащих - {vka?.pps_stat?.military_civil_perc?.military}%</span>
          <span className={styles.info}>Гражданского персонала - {vka?.pps_stat?.military_civil_perc?.civil}%</span>
          
          <div className={styles.positionWrapper}>
            {vka?.pps_stat?.scientific_perc.map(el => 
                <div className={styles.position}>
                  <div className={styles.positionName}>{el.name}</div>
                  <div className={styles.positionPers}>{el.perc} %</div>
                </div>  
            )}
            </div>
          
        </div>

        <div className={styles.centerBlock}>
          <div className={styles.title}>Распределение ППС<br/>по возрасту</div>
          
          <div className={styles.centerBlockPie}>
            <div className={styles.pieChart}
            style={{
              backgroundImage: getConicGradient(vka?.pps_age?.map(el => ({name: el.name, count: el.perc}))),
              width: '230px',
              height: '230px'
            }}></div>

            <div className={styles.pieLegenda}>
              {
                vka?.pps_age?.sort( (a, b) => a.perc - b.perc).map((el, inx) => 
                  <div className={styles.entry}>
                    <div className={styles.entryText}>
                      <div className={styles.entryColor} style={{background: `${colors[inx]}`}}></div>
                      <span>{el.name}</span>
                    </div>
                    <div className={styles.entryPerc}><span>{el.perc}%</span></div>
                  </div>
                  )
              }
            </div>
          </div>

          <div className={styles.centerBlockMark}>
              <div className={styles.markWrapper}>
                <div className={styles.markTitle}>Средний балл итогового <br/> междисциплинарного экзамена</div>
                <div className={styles.markLine} style={{width: `calc(${100 / 5 * vka?.final_marks?.avg_interdisciplinary_mark}%)`}}>
                  <div className={styles.mark}>{vka?.final_marks?.avg_interdisciplinary_mark}</div>
                </div>
              </div>
              <div className={styles.markWrapper}>
                <div className={styles.markTitle}>Средний балл выпусконой <br/> квалификационной работы</div>
                <div className={styles.markLine}>
                  <div className={styles.mark}>{vka?.final_marks?.avg_graduation_mark}</div>
                </div>
              </div>
              <div className={styles.markWrapper}>
                <div className={styles.markTitle}>Средний балл государственного <br/> экзамена по фп</div>
                <div className={styles.markLine}>
                  <div className={styles.mark}>{vka?.final_marks?.avg_state_exam_mark}</div>
                </div>
              </div>
          </div>
          
        </div>

        <div className={styles.rightBlock}>
              <div className={styles.rightBlock_1}>
                <div className={styles.title}>Электронная информационно-образовательная среда</div>
                <div className={styles.infoWrapper}>
                  <div className={styles.infoItem}>
                    <div className={styles.infoItemTitle}>Электронных<br/>учебников (%)</div>
                    <div className={styles.item}>
                       <div className={styles.item_perc} style={{color: `${getColor(vka?.electronic_env?.el_textbook_perc)[1]}`}}>{vka?.electronic_env?.el_textbook_perc}%</div>
                       <svg viewBox="-50 -50 100 100">
                        <circle r="30"  className={styles.sc} style={{fill: `${getColor(vka?.electronic_env?.el_textbook_perc)[0]}`}}/>
                        <circle r="30"  className={styles.c1} 
                        style={{strokeDasharray: `${170 / 100 * vka?.electronic_env?.el_textbook_perc } 1383`, 
                                stroke: `${getColor(vka?.electronic_env?.el_textbook_perc)[1]}`}}/>
                      </svg>
                    </div>
                  </div>

                  <div className={styles.infoItem}>
                    <div className={styles.infoItemTitle}>Видеолекций (%)</div>
                    <div className={styles.item}>
                       <div className={styles.item_perc} style={{color: `${getColor(vka?.electronic_env?.video_lectures_perc)[1]}`}}>{vka?.electronic_env?.video_lectures_perc}%</div>
                       <svg viewBox="-50 -50 100 100">
                        <circle r="30"  className={styles.sc} style={{fill: `${getColor(vka?.electronic_env?.video_lectures_perc)[0]}`}}/>
                        <circle r="30"  className={styles.c1} 
                        style={{strokeDasharray: `${170 / 100 * vka?.electronic_env?.video_lectures_perc } 1383`,
                        stroke: `${getColor(vka?.electronic_env?.video_lectures_perc)[1]}`}}/>
                      </svg>
                    </div>
                  </div>

                  <div className={styles.infoItem}>
                    <div className={styles.infoItemTitle}>Электронных<br/>тестов (%)</div>
                    <div className={styles.item}>
                       <div className={styles.item_perc} style={{color: `${getColor(vka?.electronic_env?.el_test_perc)[1]}`}}>{vka?.electronic_env?.el_test_perc}%</div>
                       <svg viewBox="-50 -50 100 100">
                        <circle r="30"  className={styles.sc} style={{fill: `${getColor(vka?.electronic_env?.el_test_perc)[0]}`}}/>
                        <circle r="30"  className={styles.c1} 
                        style={{strokeDasharray: `${170 / 100 * vka?.electronic_env?.el_test_perc } 1383`,
                        stroke: `${getColor(vka?.electronic_env?.el_test_perc)[1]}`}}/>
                      </svg>
                    </div>
                  </div>

                  <div className={styles.infoItem}>
                    <div className={styles.infoItemTitle}>Локальных<br/>сетей (%)</div>
                    <div className={styles.item}>
                       <div className={styles.item_perc} style={{color: `${getColor(vka?.electronic_env?.local_network_perc)[1]}`}}>{vka?.electronic_env?.local_network_perc}%</div>
                       <svg viewBox="-50 -50 100 100">
                        <circle r="30"  className={styles.sc} style={{fill: `${getColor(vka?.electronic_env?.local_network_perc)[0]}`}}/>
                        <circle r="30"  className={styles.c1} 
                        style={{strokeDasharray: `${170 / 100 * vka?.electronic_env?.local_network_perc } 1383`,
                        stroke: `${getColor(vka?.electronic_env?.local_network_perc)[1]}`}}/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.rightBlock_2}>
                <div className={styles.rightBlock_2Left}>
                <div className={styles.rightBlock_2LeftTitle}>Укомплектованность адъюнктуры <br/>и докторантуры</div>

                  <div className={styles.rightBlock_2LeftWrapper}>
                    <div className={styles.rightBlock_2LeftTitleBlock}>
                      <div className={styles.rightBlock_2LeftTitleItem}>докторантура</div>
                      <div className={styles.rightBlock_2LeftTitleItem}>очная <br/>адъюнктура</div>
                      <div className={styles.rightBlock_2LeftTitleItem}>заочная <br/>адъюнктура</div>
                    </div>
                    <div className={styles.rightBlock_2LeftLineBlock}>
                      <div className={styles.rightBlock_2LeftLineItem}
                      style={{width: `${400 / 100 * vka?.staff_adjunct_doctor?.doctor_perc}px`}}
                      ><span>{vka?.staff_adjunct_doctor?.doctor_perc}%</span></div>
                      <div className={styles.rightBlock_2LeftLineItem}
                      style={{width: `${400 / 100 * vka?.staff_adjunct_doctor?.full_time_adjunct_perc}px`}}
                      ><span>{vka?.staff_adjunct_doctor?.full_time_adjunct_perc}%</span></div>
                      <div className={styles.rightBlock_2LeftLineItem}
                      style={{width: `${400 / 100 * vka?.staff_adjunct_doctor?.extramural_adjunct_perc}px`}}
                      ><span>{vka?.staff_adjunct_doctor?.extramural_adjunct_perc}%</span></div>
                    </div>
                  </div>
                </div>
                
                <div className={styles.rightBlock_2Right}>
                  <div className={styles.title}>Причина <br/> отсутствия <br/>на занятиях</div>

                  <div className={styles.centerBlockPie_absence}>
                    <div className={styles.pieChart}
                    style={{
                      backgroundImage: getConicGradient(vka?.absence_reason?.map(el => ({name: el.name, count: el.perc}))),
                      width: '230px',
                      height: '230px'
                    }}></div>

                    
                  </div>
                  <div className={styles.pieLegenda_absence}>
                      {
                        vka?.absence_reason?.sort( (a, b) => a.perc - b.perc).map((el, inx) => 
                          <div className={styles.entry}>
                            <div className={styles.entryText}>
                              <div className={styles.entryColor} style={{background: `${colors[inx]}`}}></div>
                              <span>{el.name}</span>
                            </div>
                            <div className={styles.entryPerc}><span>{el.perc}%</span></div>
                          </div>
                          )
                      }
                    </div>
                </div>
              </div>

              <div className={styles.rightBlock_3}>
                    <div>
                      <div className={styles.title}>Динамика успеваемости в течение года (ср. балл)</div>
                      <div className={styles.progressBlock}>
                      {
                        vka?.progress_dynamics?.map((el) => 
                        <div className={styles.progress}>
                          <div className={styles.score} style={{height: `${150 / 5 * el.avg_score}px`}}><span>{el.avg_score}</span></div>  
                          <div className={styles.month}>{getRusMonth(el.month)?.ru}</div>
                        </div>
                        )
                      }
                      </div>
                    </div>
                    
                    
                    <div></div>
              </div>
        </div>

        </div>
      }
      <BtnBack/>

    </div>
  )
}

const mapStateToProps = ({report: { university, vka }}) => ({ university, vka });

  
export default connect(mapStateToProps, { getVka, getUniversity, trashVkaData })(IndicatorsDashbordActivity);